import GetCare from './GetCare'
export default GetCare
